import PlacesContext from './PlacesContext';

const PlacesProvider = ({ children, places, type }) => {
  return <PlacesContext.Provider value={{ places, type }}>{children}</PlacesContext.Provider>;
};

export default PlacesProvider;
